/* Atipiná PDP — Quiz "Descubra o tamanho" v9
   2026-05-27: + tracking Klaviyo event "Used Size Advisor" no finalize.
   2026-05-28 (Fase 2): + card de captura, multi-filho (child_1..child_4),
   camada "pra quem é?", loop "medir outro".
   2026-05-28 (fix opt-in v2): a API /client/subscriptions/ NÃO aceita o objeto
   `subscriptions` dentro do profile (retorna 400). Removido — pra lista single
   opt-in basta email + lista que o Klaviyo inscreve com consentimento.
   Submit faz 2 chamadas: /client/subscriptions/ (opt-in) + /client/profiles/ (props). */
(function(){
  'use strict';

  var KLAVIYO_COMPANY_ID = 'TBqNEx';
  var KLAVIYO_LIST_ID = 'TE34Rq';
  var KLAVIYO_REVISION = '2024-10-15';
  var CHILD_CAP = 4;
  var CHILDREN_KEY = 'atipina_children';

  var SIZE_RANGES = {
    '1':  { age: [0, 2],    height: [70, 85],   weight: [7, 11] },
    '2':  { age: [2, 3],    height: [85, 98],   weight: [11, 14] },
    '3':  { age: [3, 4],    height: [98, 108],  weight: [14, 17] },
    '4':  { age: [4, 6],    height: [108, 117], weight: [17, 21] },
    '6':  { age: [6, 8],    height: [117, 127], weight: [21, 26] },
    '8':  { age: [8, 10],   height: [127, 137], weight: [26, 32] },
    'PP': { age: [0, 0],    height: [70, 85],   weight: [7, 11] },
    'P':  { age: [0, 0],    height: [85, 100],  weight: [11, 14] },
    'M':  { age: [0, 0],    height: [100, 115], weight: [14, 18] },
    'G':  { age: [0, 0],    height: [115, 128], weight: [18, 24] },
    'GG': { age: [0, 0],    height: [128, 140], weight: [24, 30] }
  };

  var ABS_MAX_AGE = 11;
  var ABS_MAX_HEIGHT = 145;
  var ABS_MAX_WEIGHT = 38;
  var ABS_MIN_HEIGHT = 50;
  var ABS_MIN_WEIGHT = 4;

  var STORAGE_KEY = 'pdpLiveAdvisorProfile';
  var TOTAL_STEPS = 3;

  function $(sel, ctx){ return (ctx || document).querySelector(sel); }
  function $$(sel, ctx){ return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function inRange(val, range){ return val >= range[0] && val <= range[1]; }
  function distance(val, range){
    if (inRange(val, range)) return 0;
    return Math.min(Math.abs(val - range[0]), Math.abs(val - range[1]));
  }

  function scoreSize(sizeKey, answers){
    var data = SIZE_RANGES[sizeKey];
    if (!data) return -Infinity;
    var score = 0;
    if (answers.age != null) {
      if (data.age[0] === 0 && data.age[1] === 0) {
      } else if (inRange(answers.age, data.age)) {
        score += 3;
      } else {
        score -= distance(answers.age, data.age) * 0.5;
      }
    }
    if (answers.height != null) {
      if (inRange(answers.height, data.height)) {
        score += 4;
      } else {
        score -= distance(answers.height, data.height) * 0.3;
      }
    }
    if (answers.weight != null) {
      if (inRange(answers.weight, data.weight)) {
        score += 3;
      } else {
        score -= distance(answers.weight, data.weight) * 0.4;
      }
    }
    return score;
  }

  function checkOutOfRange(answers){
    var reasons = [];
    if (answers.age != null && answers.age > ABS_MAX_AGE) reasons.push('idade');
    if (answers.height != null && answers.height > ABS_MAX_HEIGHT) reasons.push('altura');
    if (answers.weight != null && answers.weight > ABS_MAX_WEIGHT) reasons.push('peso');
    if (reasons.length > 0) return { direction: 'above', reasons: reasons };
    if (answers.height != null && answers.height < ABS_MIN_HEIGHT) return { direction: 'below', reasons: ['altura'] };
    if (answers.weight != null && answers.weight < ABS_MIN_WEIGHT) return { direction: 'below', reasons: ['peso'] };
    return null;
  }

  function recommend(answers, availableSizes){
    var oor = checkOutOfRange(answers);
    if (oor) return { outOfRange: oor };

    var candidates = availableSizes.filter(function(s){ return SIZE_RANGES[s]; });
    if (!candidates.length) candidates = availableSizes.slice();
    var ranked = candidates.map(function(size){
      return { size: size, score: scoreSize(size, answers) };
    }).sort(function(a, b){ return b.score - a.score; });
    var top = ranked[0];
    var second = ranked[1];

    if (!top || top.score < 1) {
      return { lowConfidence: true, primary: top ? top.size : null };
    }

    var isBorderline = second && (top.score - second.score) < 1.5 && top.score >= 3;
    var confidencePercent;
    if (top.score >= 8) confidencePercent = 92;
    else if (top.score >= 5) confidencePercent = 84;
    else if (top.score >= 3) confidencePercent = 71;
    else confidencePercent = 58;
    return { primary: top.size, secondary: isBorderline ? second.size : null, confidence: confidencePercent };
  }

  function trackKlaviyo(answers, result){
    try {
      var pdp = document.querySelector('product-component.pdp-live');
      var productHandle = pdp ? pdp.getAttribute('data-product-handle') : '';
      var productId = pdp ? pdp.getAttribute('data-product-id') : '';
      var productTitle = '';
      var titleEl = document.querySelector('.pdp-live__title');
      if (titleEl) productTitle = titleEl.textContent.trim();
      var priceEl = document.querySelector('.pdp-live__price-current');
      var priceText = priceEl ? priceEl.textContent.trim() : '';

      var props = {
        idade: answers.age,
        altura_cm: answers.height,
        peso_kg: answers.weight,
        produto: productTitle,
        produto_handle: productHandle,
        produto_id: productId,
        produto_url: window.location.origin + (productHandle ? '/products/' + productHandle : window.location.pathname),
        produto_preco_exibido: priceText,
        timestamp: new Date().toISOString()
      };

      if (result.outOfRange) {
        props.resultado = 'fora_de_faixa';
        props.direcao_fora = result.outOfRange.direction;
        props.motivos_fora = result.outOfRange.reasons.join(', ');
      } else if (result.lowConfidence) {
        props.resultado = 'baixa_confianca';
        props.tamanho_sugerido = result.primary || '';
      } else {
        props.resultado = 'sucesso';
        props.tamanho_recomendado = result.primary;
        props.tamanho_secundario = result.secondary || '';
        props.confianca_percent = result.confidence;
      }

      if (typeof window.klaviyo !== 'undefined' && typeof window.klaviyo.push === 'function') {
        window.klaviyo.push(['track', 'Used Size Advisor', props]);
      } else {
        window._learnq = window._learnq || [];
        window._learnq.push(['track', 'Used Size Advisor', props]);
      }
      if (window.console) console.log('[Atipiná] Klaviyo event Used Size Advisor (anônimo) enviado:', props);
    } catch(err){
      if (window.console) console.warn('[Atipiná] Falha no Klaviyo track:', err);
    }
  }

  function loadProfile(){
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data.savedAt || Date.now() - data.savedAt > 30 * 24 * 60 * 60 * 1000) return null;
      return data;
    } catch(e){ return null; }
  }

  function saveProfile(answers){
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        age: answers.age, height: answers.height, weight: answers.weight,
        savedAt: Date.now()
      }));
    } catch(e){}
  }

  function getChildren(){
    try { return JSON.parse(sessionStorage.getItem(CHILDREN_KEY) || '[]'); } catch(e){ return []; }
  }
  function saveChildren(arr){
    try { sessionStorage.setItem(CHILDREN_KEY, JSON.stringify(arr)); } catch(e){}
  }

  /* opt-in: email + lista (sem objeto subscriptions — rejeitado com 400).
     Single opt-in da lista já marca consentimento. */
  function subscribeToList(email){
    var payload = { data: { type: 'subscription', attributes: {
      custom_source: 'Size Advisor',
      profile: { data: { type: 'profile', attributes: { email: email } } }
    }, relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST_ID } } } } };
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': KLAVIYO_REVISION },
      body: JSON.stringify(payload)
    }).then(function(r){
      if ((r.status >= 200 && r.status < 300) || r.status === 202) return true;
      return r.text().then(function(t){ throw new Error('subscribe ' + r.status + ' ' + t); });
    });
  }

  function updateProfileProperties(email, properties){
    var payload = { data: { type: 'profile', attributes: { email: email, properties: properties } } };
    return fetch('https://a.klaviyo.com/client/profiles/?company_id=' + KLAVIYO_COMPANY_ID, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': KLAVIYO_REVISION },
      body: JSON.stringify(payload)
    }).then(function(r){
      if ((r.status >= 200 && r.status < 300) || r.status === 202 || r.status === 409) return true;
      return r.text().then(function(t){ throw new Error('profile ' + r.status + ' ' + t); });
    });
  }

  function setupAdvisor(modal){
    if (modal.__advisorBound) return;
    modal.__advisorBound = true;

    var sectionEl = modal.closest('product-component') || document.body;
    var availableSizesStr = modal.getAttribute('data-available-sizes') || '';
    var availableSizes = availableSizesStr.split(',').map(function(s){ return s.trim(); }).filter(Boolean);

    var answers = { age: null, height: null, weight: null };
    var currentStep = 0;
    var lastResult = null;

    var steps = $$('.pdp-live__advisor-step', modal);
    var progressFill = $('[data-progress-fill]', modal);
    var progressLabel = $('[data-progress-label]', modal);
    var navEl = $('[data-advisor-nav]', modal);
    var backBtn = $('[data-back]', modal);
    var nextBtn = $('[data-next]', modal);

    var resultEl = $('.pdp-live__advisor-result', modal);
    var resultLabel = $('.pdp-live__advisor-result-label', modal);
    var sizeEl = $('[data-recommended-size]', modal);
    var explEl = $('[data-result-explanation]', modal);
    var ctaSize = $('[data-cta-size]', modal);
    var statPct = $('[data-stat-percent]', modal);
    var statBlock = $('.pdp-live__advisor-result-stat', modal);
    var selectBtn = $('[data-select-recommended]', modal);
    var seeTableBtn = $('[data-see-size-table]', modal);

    var captureEl = $('[data-advisor-capture]', modal);
    var capForm = $('[data-capture-form]', modal);
    var capEmail = $('[data-capture-email]', modal);
    var capKnown = $('[data-capture-known]', modal);
    var capKnownText = $('[data-capture-known-text]', modal);
    var capNotYou = $('[data-capture-not-you]', modal);
    var capName = $('[data-capture-name]', modal);
    var capBirthday = $('[data-capture-birthday]', modal);
    var capSubmit = $('[data-capture-submit]', modal);
    var capFeedback = $('[data-capture-feedback]', modal);
    var capWho = $('[data-capture-who]', modal);
    var capChips = $('[data-capture-chips]', modal);
    var capSuccess = $('[data-capture-success]', modal);
    var capSuccessText = $('[data-capture-success-text]', modal);
    var capAnother = $('[data-capture-another]', modal);
    var selectedChildIndex = -1;

    function showStep(idx){
      currentStep = idx;
      steps.forEach(function(s, i){ s.classList.toggle('is-current', i === idx); });
      var isResult = idx >= TOTAL_STEPS;
      var progressPct = isResult ? 100 : ((idx / TOTAL_STEPS) * 100);
      if (progressFill) progressFill.style.width = progressPct + '%';
      if (progressLabel) progressLabel.textContent = isResult ? 'Resultado' : ('Pergunta ' + (idx + 1) + ' de ' + TOTAL_STEPS);
      if (navEl) navEl.style.display = isResult ? 'none' : '';
      if (backBtn) backBtn.style.visibility = idx === 0 ? 'hidden' : 'visible';
      if (nextBtn) {
        if (idx === 0) {
          nextBtn.style.visibility = 'hidden';
        } else {
          nextBtn.style.visibility = 'visible';
          nextBtn.textContent = idx === TOTAL_STEPS - 1 ? 'Ver recomendação →' : 'Próximo →';
        }
      }
    }

    function goNext(){
      if (currentStep === 1) {
        var heightInput = $('[data-height]', modal);
        var val = parseFloat(heightInput.value);
        if (heightInput.value && !isNaN(val) && val >= 40 && val <= 220) {
          answers.height = val;
        } else if (heightInput.value) {
          heightInput.focus();
          return;
        }
      }
      if (currentStep === 2) {
        var weightInput = $('[data-weight]', modal);
        var w = parseFloat(weightInput.value);
        if (weightInput.value && !isNaN(w) && w >= 3 && w <= 150) {
          answers.weight = w;
        } else if (weightInput.value) {
          weightInput.focus();
          return;
        }
      }
      if (currentStep + 1 >= TOTAL_STEPS) finalize();
      else showStep(currentStep + 1);
    }

    function goBack(){ if (currentStep > 0) showStep(currentStep - 1); }

    function renderOutOfRange(oor){
      resultEl.classList.add('pdp-live__advisor-result--warning');
      if (resultLabel) resultLabel.textContent = oor.direction === 'above' ? 'Esse perfil está acima dos tamanhos da Ati+Piná' : 'Esse perfil está abaixo dos tamanhos da Ati+Piná';
      sizeEl.textContent = '!';
      sizeEl.style.fontSize = '40px';
      var lista = oor.reasons.join(' / ');
      if (oor.direction === 'above') {
        explEl.innerHTML = 'A Ati+Piná veste crianças <strong>até ~10 anos</strong> (tamanho 8 é o maior, ~137 cm e 32 kg). O perfil informado <strong>' + lista + '</strong> está acima dessa faixa — nossas peças podem ficar pequenas.';
      } else {
        explEl.innerHTML = 'O perfil informado está abaixo da nossa menor faixa. Verifique se os valores estão corretos.';
      }
      if (statBlock) statBlock.style.display = 'none';
      if (selectBtn) selectBtn.style.display = 'none';
      if (seeTableBtn) seeTableBtn.style.display = '';
    }

    function renderLowConfidence(result){
      resultEl.classList.add('pdp-live__advisor-result--warning');
      if (resultLabel) resultLabel.textContent = 'Não encontramos um tamanho perfeito';
      sizeEl.textContent = result.primary || '?';
      sizeEl.style.fontSize = '64px';
      explEl.textContent = 'O perfil informado não se encaixa bem em nenhum dos nossos tamanhos. Confira a tabela completa abaixo para decidir.';
      if (statBlock) statBlock.style.display = 'none';
      if (selectBtn) selectBtn.style.display = 'none';
      if (seeTableBtn) seeTableBtn.style.display = '';
    }

    function renderNormal(result){
      resultEl.classList.remove('pdp-live__advisor-result--warning');
      if (resultLabel) resultLabel.textContent = 'Encontramos o tamanho ideal:';
      sizeEl.textContent = result.primary;
      sizeEl.style.fontSize = '64px';
      ctaSize.textContent = result.primary;
      statPct.textContent = result.confidence + '%';
      var parts = [];
      if (answers.age != null) parts.push(answers.age + ' anos');
      if (answers.height != null) parts.push(answers.height + ' cm');
      if (answers.weight != null) parts.push(answers.weight + ' kg');
      var perfil = parts.length ? 'Com base no perfil informado (' + parts.join(', ') + '), ' : 'Com base nas respostas, ';
      if (result.secondary) {
        explEl.textContent = perfil + 'o tamanho ' + result.primary + ' deve servir melhor — mas pode ficar entre ' + result.primary + ' e ' + result.secondary + '.';
      } else {
        explEl.textContent = perfil + 'o tamanho ' + result.primary + ' é a melhor escolha.';
      }
      if (statBlock) statBlock.style.display = '';
      if (selectBtn) {
        selectBtn.style.display = '';
        selectBtn.setAttribute('data-target-size', result.primary);
      }
      if (seeTableBtn) seeTableBtn.style.display = '';
    }

    function finalize(){
      var result = recommend(answers, availableSizes);
      lastResult = result;
      saveProfile(answers);
      trackKlaviyo(answers, result);
      if (result.outOfRange) {
        renderOutOfRange(result.outOfRange);
      } else if (result.lowConfidence) {
        renderLowConfidence(result);
      } else {
        renderNormal(result);
      }
      showStep(TOTAL_STEPS);
      showCapture(result);
    }

    function restart(){
      answers = { age: null, height: null, weight: null };
      $$('.pdp-live__advisor-chip.is-active', modal).forEach(function(b){ b.classList.remove('is-active'); });
      $('[data-height]', modal).value = '';
      $('[data-weight]', modal).value = '';
      resultEl.classList.remove('pdp-live__advisor-result--warning');
      if (captureEl) captureEl.hidden = true;
      showStep(0);
    }

    function refreshKnownEmailUI(){
      var id = (window.AtipinaEmail && window.AtipinaEmail.get) ? window.AtipinaEmail.get() : null;
      if (id && id.email) {
        if (capEmail) capEmail.style.display = 'none';
        if (capKnown) {
          capKnown.hidden = false;
          var masked = window.AtipinaEmail.mask ? window.AtipinaEmail.mask(id.email) : id.email;
          capKnownText.textContent = 'Vamos guardar no seu e-mail ' + masked + ' 💜';
        }
      } else {
        if (capEmail) capEmail.style.display = '';
        if (capKnown) capKnown.hidden = true;
      }
    }

    function selectChild(i){
      selectedChildIndex = i;
      var children = getChildren();
      $$('.pdp-live__advisor-capture-chip', capChips).forEach(function(b){
        var isNew = b.getAttribute('data-new') === '1';
        var bi = parseInt(b.getAttribute('data-child-index'), 10);
        var active = (i === -1 && isNew) || (!isNew && bi === i);
        b.classList.toggle('is-active', active);
      });
      if (i >= 0 && children[i]) {
        if (capName) capName.value = children[i].name || '';
        if (capBirthday) capBirthday.value = children[i].birthday || '';
      } else {
        if (capName) capName.value = '';
        if (capBirthday) capBirthday.value = '';
      }
    }

    function renderWhoChips(){
      if (!capWho || !capChips) return;
      var children = getChildren();
      if (!children.length) {
        capWho.hidden = true;
        selectedChildIndex = -1;
        return;
      }
      capWho.hidden = false;
      capChips.innerHTML = '';
      children.forEach(function(c, i){
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'pdp-live__advisor-capture-chip';
        b.setAttribute('data-child-index', i);
        b.textContent = c.name || ('Pequeno ' + (i + 1));
        b.addEventListener('click', function(){ selectChild(i); });
        capChips.appendChild(b);
      });
      if (children.length < CHILD_CAP) {
        var nb = document.createElement('button');
        nb.type = 'button';
        nb.className = 'pdp-live__advisor-capture-chip pdp-live__advisor-capture-chip--new';
        nb.setAttribute('data-new', '1');
        nb.textContent = '+ Novo pequeno';
        nb.addEventListener('click', function(){ selectChild(-1); });
        capChips.appendChild(nb);
      }
      selectChild(-1);
    }

    function showCapture(result){
      if (!captureEl) return;
      captureEl.hidden = false;
      if (capSuccess) capSuccess.hidden = true;
      if (capForm) capForm.style.display = '';
      if (capFeedback) { capFeedback.textContent = ''; capFeedback.className = 'pdp-live__advisor-capture-feedback'; }
      if (capSubmit) { capSubmit.disabled = false; capSubmit.textContent = 'Guardar tamanho 💜'; }
      refreshKnownEmailUI();
      renderWhoChips();
    }

    function fireIdentifiedEvent(email, props, childName, size){
      try {
        var eventProps = {};
        Object.keys(props).forEach(function(k){ eventProps[k] = props[k]; });
        eventProps.crianca = childName || '';
        eventProps.tamanho = size || '';
        var payload = { data: { type: 'event', attributes: {
          properties: eventProps,
          metric: { data: { type: 'metric', attributes: { name: 'Used Size Advisor' } } },
          profile: { data: { type: 'profile', attributes: { email: email } } }
        }}};
        fetch('https://a.klaviyo.com/client/events/?company_id=' + KLAVIYO_COMPANY_ID, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'revision': KLAVIYO_REVISION },
          body: JSON.stringify(payload)
        }).catch(function(){});
      } catch(e){}
    }

    function finishCapture(email, childName, birthday, size, targetIndex, props){
      var children = getChildren();
      children[targetIndex] = {
        name: childName,
        birthday: birthday,
        size: size,
        age: answers.age,
        measuredAt: props['child_' + (targetIndex + 1) + '_size_measured_at']
      };
      saveChildren(children);

      if (window.AtipinaEmail && window.AtipinaEmail.set) window.AtipinaEmail.set(email, childName);

      if (capForm) capForm.style.display = 'none';
      if (capSuccess) {
        capSuccess.hidden = false;
        capSuccessText.textContent = childName
          ? ('✓ Prontinho! Vamos cuidar do guarda-roupa de ' + childName + ' 💜')
          : '✓ Prontinho! Tamanho guardado 💜';
        if (capAnother) capAnother.hidden = (children.length >= CHILD_CAP);
      }
      if (window.console) console.log('[Atipiná] Captura salva. Filho #' + (targetIndex + 1) + ':', children[targetIndex]);
    }

    function submitCapture(){
      var id = (window.AtipinaEmail && window.AtipinaEmail.get) ? window.AtipinaEmail.get() : null;
      var email = (id && id.email) ? id.email : (capEmail ? capEmail.value.trim().toLowerCase() : '');
      var valid = (window.AtipinaEmail && window.AtipinaEmail.isValidEmail)
        ? window.AtipinaEmail.isValidEmail(email)
        : /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

      if (capFeedback) { capFeedback.className = 'pdp-live__advisor-capture-feedback'; capFeedback.textContent = ''; }

      if (!valid) {
        if (capFeedback) { capFeedback.classList.add('is-error'); capFeedback.textContent = 'Digite um e-mail válido pra gente guardar.'; }
        return;
      }

      var childName = capName ? capName.value.trim() : '';
      var birthday = capBirthday ? capBirthday.value : '';
      var children = getChildren();
      var targetIndex = (selectedChildIndex >= 0) ? selectedChildIndex : children.length;

      if (targetIndex >= CHILD_CAP) {
        if (capFeedback) { capFeedback.classList.add('is-error'); capFeedback.textContent = 'Você já cadastrou o máximo de pequenos por aqui 💜'; }
        return;
      }

      var N = targetIndex + 1;
      var sizeForCapture = (lastResult && !lastResult.outOfRange && lastResult.primary) ? String(lastResult.primary) : '';

      var props = {};
      if (childName) props['child_' + N + '_name'] = childName;
      if (birthday) props['child_' + N + '_birthday'] = birthday;
      if (sizeForCapture) props['child_' + N + '_size'] = sizeForCapture;
      if (answers.age != null) props['child_' + N + '_age'] = answers.age;
      props['child_' + N + '_size_measured_at'] = new Date().toISOString();

      if (capSubmit) { capSubmit.disabled = true; capSubmit.textContent = 'Guardando…'; }

      var subP = subscribeToList(email);
      var propP = updateProfileProperties(email, props);

      var settled = 0, subOk = false, subErr = null, propOk = false, propErr = null;
      function afterBoth(){
        settled++;
        if (settled < 2) return;
        if (window.console) {
          console.log('[Atipiná] opt-in (lista+consent):', subOk ? 'OK' : ('FALHOU ' + (subErr && subErr.message)));
          console.log('[Atipiná] propriedades child_' + N + ':', propOk ? 'OK' : ('FALHOU ' + (propErr && propErr.message)));
        }
        if (!propOk) {
          try {
            window._learnq = window._learnq || [];
            var idObj = { '$email': email };
            Object.keys(props).forEach(function(k){ idObj[k] = props[k]; });
            window._learnq.push(['identify', idObj]);
          } catch(e){}
        }
        fireIdentifiedEvent(email, props, childName, sizeForCapture);
        finishCapture(email, childName, birthday, sizeForCapture, targetIndex, props);
      }
      subP.then(function(){ subOk = true; }).catch(function(e){ subErr = e; }).then(afterBoth);
      propP.then(function(){ propOk = true; }).catch(function(e){ propErr = e; }).then(afterBoth);
    }

    function selectSizeInPDP(size){
      var pdp = sectionEl;
      var sizeRadios = $$('.pdp-live__variant--size input[type="radio"]', pdp);
      var found = sizeRadios.find(function(r){ return r.value === size; });
      if (found) {
        sizeRadios.forEach(function(r){ r.checked = false; });
        found.checked = true;
        found.dispatchEvent(new Event('change', { bubbles: true }));
        var legend = found.closest('.pdp-live__variant').querySelector('[data-option-value]');
        if (legend) legend.textContent = size;
      }
    }

    function openSizeTableFromAdvisor(){
      var sizeBtn = sectionEl.querySelector('[data-open-size-modal]');
      if (sizeBtn) {
        if (typeof modal.close === 'function') modal.close();
        else modal.removeAttribute('open');
        setTimeout(function(){ sizeBtn.click(); }, 80);
      }
    }

    $$('.pdp-live__advisor-chip[data-age]', modal).forEach(function(chip){
      chip.addEventListener('click', function(){
        $$('.pdp-live__advisor-chip[data-age]', modal).forEach(function(c){ c.classList.remove('is-active'); });
        chip.classList.add('is-active');
        answers.age = parseInt(chip.getAttribute('data-age'), 10);
        setTimeout(function(){ showStep(1); }, 200);
      });
    });

    if (nextBtn) nextBtn.addEventListener('click', goNext);
    if (backBtn) backBtn.addEventListener('click', goBack);

    var skipHeight = $('[data-skip-height]', modal);
    if (skipHeight) skipHeight.addEventListener('click', function(){
      answers.height = null;
      $('[data-height]', modal).value = '';
      showStep(2);
    });

    var skipWeight = $('[data-skip-weight]', modal);
    if (skipWeight) skipWeight.addEventListener('click', function(){
      answers.weight = null;
      $('[data-weight]', modal).value = '';
      finalize();
    });

    if (selectBtn) selectBtn.addEventListener('click', function(){
      var size = selectBtn.getAttribute('data-target-size');
      if (size) selectSizeInPDP(size);
      closeModal();
    });

    if (seeTableBtn) seeTableBtn.addEventListener('click', openSizeTableFromAdvisor);

    var restartBtn = $('[data-restart]', modal);
    if (restartBtn) restartBtn.addEventListener('click', restart);

    if (capForm) capForm.addEventListener('submit', function(e){ e.preventDefault(); submitCapture(); });
    if (capNotYou) capNotYou.addEventListener('click', function(){
      if (window.AtipinaEmail && window.AtipinaEmail.clear) window.AtipinaEmail.clear();
      refreshKnownEmailUI();
      if (capEmail) { capEmail.value = ''; capEmail.focus(); }
    });
    if (capAnother) capAnother.addEventListener('click', function(){ restart(); });

    [$('[data-height]', modal), $('[data-weight]', modal)].forEach(function(input){
      if (!input) return;
      input.addEventListener('keydown', function(e){
        if (e.key === 'Enter') { e.preventDefault(); goNext(); }
      });
    });

    $$('[data-close-advisor-modal]', modal).forEach(function(b){ b.addEventListener('click', closeModal); });
    modal.addEventListener('click', function(e){
      if (!e.target.closest('.pdp-live__advisor-inner')) closeModal();
    });
    modal.addEventListener('close', function(){ document.body.style.overflow = ''; });

    function closeModal(){
      if (typeof modal.close === 'function') modal.close();
      else modal.removeAttribute('open');
      document.body.style.overflow = '';
    }

    var saved = loadProfile();
    if (saved) {
      if (saved.age != null) {
        var chip = $$('.pdp-live__advisor-chip[data-age="' + saved.age + '"]', modal)[0];
        if (chip) chip.classList.add('is-active');
        answers.age = saved.age;
      }
      if (saved.height != null) {
        var h = $('[data-height]', modal);
        if (h) h.value = saved.height;
        answers.height = saved.height;
      }
      if (saved.weight != null) {
        var w = $('[data-weight]', modal);
        if (w) w.value = saved.weight;
        answers.weight = saved.weight;
      }
    }

    showStep(0);
  }

  function init(){
    $$('.pdp-live__advisor').forEach(setupAdvisor);
    $$('[data-open-advisor-modal]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var modalId = btn.getAttribute('data-open-advisor-modal');
        var modal = document.getElementById(modalId);
        if (!modal) return;
        if (typeof modal.showModal === 'function') modal.showModal();
        else modal.setAttribute('open', '');
        document.body.style.overflow = 'hidden';
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
